import React from 'react';
import HarbourPathwayMark from './HarbourPathwayMark';
import HarbourCountPill from './HarbourCountPill';
import HarbourIcon from './HarbourIcon';
import './harbour.css';

/*
 * Harbour segmented control: the shared shell behind the filter tabs and the
 * cards/table view switch. Rendered as a toolbar of toggle buttons; the
 * active segment is white on the tinted track. A tab with lockedWhenEmpty
 * and a zero count renders locked (muted, lock icon, not selectable) — the
 * designed state for "Not on a pathway yet" with nothing in it.
 */
export default function HarbourSegmented({ items, activeKey, onChange, ariaLabel }) {
  return (
    <div className="harbour-segmented" role="group" aria-label={ariaLabel}>
      {items.map((item) => {
        const active = item.key === activeKey;
        const locked = Boolean(item.lockedWhenEmpty) && item.count === 0 && !active;
        return (
          <button
            key={item.key}
            type="button"
            className={[
              'harbour-segmented__item',
              active ? 'harbour-segmented__item--active' : '',
              locked ? 'harbour-segmented__item--locked' : '',
            ].filter(Boolean).join(' ')}
            aria-pressed={active}
            aria-disabled={locked || undefined}
            onClick={() => { if (!locked) onChange(item.key); }}
          >
            {item.pathway && <HarbourPathwayMark pathway={item.pathway} />}
            {item.label}
            {typeof item.count === 'number' && (
              <HarbourCountPill count={item.count} tone={active ? 'active' : item.count === 0 ? 'neutralZero' : 'default'} />
            )}
            {locked && <HarbourIcon name="lock" size={16} />}
          </button>
        );
      })}
    </div>
  );
}
